import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import Image from 'components/AppImage';


const CategoryTable = ({ 
  categories, 
  onEdit, 
  onViewDetails, 
  onToggleStatus, 
  selectedCategory, 
  onSelectCategory,
  onSelectAll,
  isAllSelected 
}) => {
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  const [roleDescription, setRoleDescription] = useState('N/A');

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const sortedCategories = [...categories]?.sort((a, b) => {
    let aValue = a?.[sortField];
    let bValue = b?.[sortField];
    
    if (sortField === 'hireDate') {
      aValue = new Date(aValue);
      bValue = new Date(bValue);
    }
    
    if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });

  const getStatusBadge = (status) => {
    const statusConfig = {
      active: { color: 'bg-green-500 text-success-foreground', label: 'Active' },
      inactive: { color: 'bg-muted text-muted-foreground', label: 'Inactive' },
      suspended: { color: 'bg-warning text-warning-foreground', label: 'Suspended' }
    };
    
    // const config = statusConfig?.[status] || statusConfig?.inactive;
    const config = status? statusConfig.active : statusConfig.inactive;
    
    return (
      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${config?.color}`}>
        <div className={`status-indicator mr-1 ${status ? 'active' : 'inactive'}`}></div>
        {config?.label}
      </span>
    );
  };

  const getRoleBadge = (role) => {
    let roleDescription = 'N/A';
    const roleColors = {
      'Full-Access': 'bg-primary text-primary-foreground',
      'Supervisor': 'bg-accent text-accent-foreground',
      'Washer': 'bg-secondary text-secondary-foreground',
      'Cashier': 'bg-muted text-muted-foreground'
    };


    if((role.reporting && role.releasing && role.scanning) || role.owner || role.admin ){
      roleDescription = 'Full-Access';
    }
    else if(role.releasing){
      roleDescription = 'Releaser'; 
    }
    else if(role.reporting){
      roleDescription = 'Reporter'; 
    }
    
    return (
      <span className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${roleColors[roleDescription] || 'bg-muted text-muted-foreground'}`}>
        {roleDescription}
      </span>
    );
  };

  const SortButton = ({ field, children }) => (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => handleSort(field)}
      className="h-auto p-1 font-medium text-left justify-start hover:bg-transparent"
    >
      {children}
      <Icon 
        name={sortField === field ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} 
        size={14} 
        className="ml-1"
      />
    </Button>
  );

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      {/* Desktop Table View */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="w-12 p-4">
                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={onSelectAll}
                  className="rounded border-border"
                />
              </th>
              <th className="text-left p-4">
                <SortButton field="name">Category Name</SortButton>
              </th>
              <th className="text-left p-4">
                <SortButton field="role">Description</SortButton>
              </th>
    
              <th className="text-left p-4">
                <SortButton field="hireDate">Created Date</SortButton>
              </th>
              <th className="text-left p-4">
                <SortButton field="status">Status</SortButton>
              </th>
              <th className="text-center p-4 w-32">Actions</th>
            </tr>
          </thead>
          <tbody>
            {sortedCategories?.map((category) => (
              <tr key={category?.id} className="border-b border-border hover:bg-muted/30 transition-smooth">
                <td className="p-4">
                  <input
                    type="checkbox"
                    checked={selectedCategory?.includes(category?.id)}
                    onChange={() => onSelectCategory(category?.id)}
                    className="rounded border-border"
                  />
                </td>
                <td className="p-4">
                  <div className="flex items-center space-x-3">
                    <div>
                      <div className="font-medium text-foreground">{category?.name}</div>
                      {/* <div className="text-sm text-muted-foreground">ID: {staff?.employeeId}</div> */}
                    </div>
                  </div>
                </td>
                <td className="p-4">
                  <div className="font-medium text-foreground">{category?.description}</div>
                </td>
                {/* <td className="p-4">
                  <div className="space-y-1">
                    <div className="text-sm text-foreground">{category?.name}</div>
                  </div>
                </td> */}
                <td className="p-4">
                  <div className="text-sm text-foreground">
                    {new Date(category.created)?.toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric'
                    })}
                  </div>
                </td>
                <td className="p-4">
                  {getStatusBadge(category?.active)}
                </td>
                <td className="p-4">
                  <div className="flex items-center justify-center space-x-1">
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onViewDetails(category)}
                      className="h-8 w-8 rounded"
                    >
                      <Icon name="Eye" size={16} />
                    </Button>
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onEdit(category)}
                      className="h-8 w-8 rounded"
                    >
                      <Icon name="Edit" size={16} />
                    </Button>
                    {/* <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onToggleStatus(category)}
                      className={`h-8 w-8 text-red-500 hover:bg-red-500 hover:rounded`}
                    >
                      <Icon name={category?.active? 'Trash2' : 'UserCheck'} size={16} />
                    </Button> */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Mobile/Tablet Card View */}
      <div className="lg:hidden space-y-4 p-4">
        {sortedCategories?.map((category) => (
          <div key={category?.id} className="bg-card border border-border rounded-lg p-4 space-y-3">
            <div className="flex items-start justify-between">
              <div className="flex items-center space-x-3 flex-1">
                {/* <input
                  type="checkbox"
                  checked={selectedCategory?.includes(category?.id)}
                  onChange={() => onSelectCategory(category?.id)}
                  className="rounded border-border mt-1"
                /> */}
 
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-foreground truncate">{category?.name}</div>
                  <div className="mt-1">{getStatusBadge(category?.active)}</div>
                </div>
              </div>
              {/* <div className="flex items-center space-x-1">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onViewDetails(category)}
                  className="h-8 w-8"
                >
                  <Icon name="Eye" size={16} />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onEdit(category)}
                  className="h-8 w-8"
                >
                  <Icon name="Edit" size={16} />
                </Button>
              </div> */}
            </div>
            
            <div className="grid grid-cols-1 gap-4 text-sm">
              <div>
                <div className="text-muted-foreground">Name</div>
                <div className="text-foreground truncate">{category?.name}</div>
              </div>
              <div>
                <div className="text-muted-foreground">Description</div>
                <div className="text-foreground">{category?.description}</div>
              </div>
              <div>
                <div className="text-muted-foreground">Created</div>
                <div className="text-foreground">
                  {new Date(category.created)?.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                  })}
                </div>
              </div>
      
            </div>
            
            <div className="flex justify-end pt-2 border-t border-border">
              <Button
                // variant={category?.active ? 'success' : 'danger'}
                size="sm"
                onClick={() => onEdit(category)}
                className="w-full rounded"
              >
                Edit
              </Button>
            </div>
          </div>
        ))}
      </div>
      {/* Empty State */}
      {categories?.length === 0 && (
        <div className="text-center py-12">
          <Icon name="FolderCog" size={48} className="text-muted-foreground mx-auto mb-4" />
          <h3 className="text-lg font-medium text-foreground mb-2">No Categories</h3>
          <p className="text-muted-foreground mb-4">Get started by adding your first category.</p>
        </div>
      )}
    </div>
  );
};

export default CategoryTable;